<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="11">
        <strong>{{name}}</strong>
        <p class="text-danger">차단은 방화벽 모드가 켜짐(차단)인 경우에만 가능합니다</p>
        <hr>
        <p>한 행에 하나만 작성합니다</p>
        <p v-if="name == 'path'">보호 해야 할 사용자 경로가 있을 경우 입력합니다</p>
        <p v-if="name == 'params'">get sql-injection과 같은 공격이 추가될 수 있습니다</p>

        <pre v-html="ex"></pre>
        <!-- ex : /admin,/admin,/admin -->
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-textarea @update="update($event, name)" id="ph_content" v-model="model" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="Path Block"  class="modal-info" v-model="explain_path" ok-only no-close-on-backdrop ok-variant="success" header-bg-variant="warning">
      <p>차단할 경로를 설정하세요</p>
      <p>ex ) http://f1security.co.kr/manager/index.html</p>
      <p>만약 /manager 경로를 차단한다면 index.html 페이지도 차단됩니다</p>
    </b-modal>
    <b-modal title="Parameter Block"  class="modal-info" v-model="explain_params" ok-only no-close-on-backdrop ok-variant="success" header-bg-variant="warning">
      <p>특정 파라미터가 포함된 요청 차단.</p>
      <p>ex ) kyword=password</p>
      <p>예시와 같이 암호 매개 변수를 차단하면 예시와 같은 암호의 매개 변수가 포함된 웹 요청이 탐지/차단됩니다.</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
